import { Container, Typography } from "@mui/material";
//
import { useAuthContext } from "./useAuthContext";
import { m } from "framer-motion";

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: string[];
  children: React.ReactNode;
};

export default function RoleBasedGuard({
  hasContent,
  roles,
  children,
}: RoleBasedGuardProp) {
  // Logic here to get current user role
  const { user } = useAuthContext();

  // const currentRole = 'user';
  const currentRole = user.isAffiliate ? "affiliate" : "msme";

  if (typeof roles !== "undefined" && !roles.includes(currentRole as string)) {
    return hasContent ? (
      <Container sx={{ textAlign: "center" }}>
        <m.div>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div>
          <Typography sx={{ color: "text.secondary" }}>
            You do not have permission to access this page
          </Typography>
        </m.div>

        <m.div></m.div>
      </Container>
    ) : null;
  }

  return <>{children}</>;
}
